import * as React from "react"
import CardGrid from "../atoms/layout/CardGrid"
import { ResourceShowcaseModel } from "./models"
import { ENTRIES_CONTENTFUL } from "./entries"
import { Container } from "react-grid-system"

const ResourceShowcase: React.FC<ResourceShowcaseModel<string>> = ({ resourcesCollection }) => {
  return (
    <Container>
      <CardGrid>
        {resourcesCollection?.items.map((item) => {
          const Component = item.__typename && ENTRIES_CONTENTFUL[item.__typename]
          if (!Component) {
            return <span>no component</span>
          }
          return <Component key={item.sys?.id} {...(item as any)} />
        })}
      </CardGrid>
    </Container>
  )
}

export default ResourceShowcase
